import {
  CREATE_STOCK_REQUEST_REQUEST,
  CREATE_STOCK_REQUEST_SUCCESS,
  CREATE_STOCK_REQUEST_ERROR
} from '~/redux/actions/types'

export const createStockRequestRequest = () => {
  return {
    type: CREATE_STOCK_REQUEST_REQUEST
  }
}

export const createStockRequestSuccess = ({ email, sku }) => {
  return {
    type: CREATE_STOCK_REQUEST_SUCCESS,
    email,
    sku
  }
}

export const createStockRequestError = error => {
  return {
    type: CREATE_STOCK_REQUEST_ERROR,
    error: true,
    payload: error
  }
}

export const createStockRequest = ({ email, sku }) => {
  return async (dispatch, _getState, { api }) => {
    dispatch(createStockRequestRequest())

    try {
      const response = await api.createStockRequest({ email, sku })
      dispatch(createStockRequestSuccess({ email, sku }))
      return response
    } catch (error) {
      dispatch(createStockRequestError(error))
      throw error
    }
  }
}
